export const gemsReward = 5;
export const visitListLimit = 100;
